require("./legend");

require("./legend/ScrollableLegendModel");

require("./legend/ScrollableLegendView");

require("./legend/scrollableLegendAction");


//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/component/legendScroll.js
// module id = 901
// module chunks = 0